import { Alert, Divider, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';

import { useDebouncedBlockContent } from '@/hooks/use-debounced-block-content';
import { useSite } from '@/hooks/use-site';
import type { CalendarBlockContent } from '@/types/database';

export function CalendarBlockEditPanel({
  content,
  onUpdate,
}: {
  content: CalendarBlockContent;
  onUpdate: (content: CalendarBlockContent) => void;
}) {
  const [draft, update] = useDebouncedBlockContent(content, onUpdate);
  const { site, save } = useSite();

  return (
    <Stack spacing={2}>
      <TextField
        label="Heading"
        value={draft.heading ?? ''}
        onChange={(event) => update({ ...draft, heading: event.target.value || undefined })}
        fullWidth
      />

      <Divider />

      <FormControlLabel
        control={
          <Switch
            checked={site?.calendar_visible_on_site ?? false}
            onChange={(event) => void save({ calendar_visible_on_site: event.target.checked })}
          />
        }
        label="Show real upcoming events from Scouting Ops Calendar"
      />
      <Typography variant="caption" color="text.secondary">
        Off by default. This is a site-wide setting — turning it on makes your calendar&apos;s public events visible everywhere this
        block appears, not just here.
      </Typography>
      {!site?.calendar_visible_on_site ? (
        <Alert severity="info">Turn this on to replace the placeholder below with your unit&apos;s real upcoming events.</Alert>
      ) : null}
    </Stack>
  );
}
